module.exports = __webpack_public_path__ + "static/img/1.9efae55.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/04/1.png
// module id = Y+CI
// module chunks = 1